import React from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import Logo from 'components/Brand/Logo';
import Header from 'components/Layout/Header';
import Footer from 'components/Layout/Footer';
import { Card, CardContent, Typography } from 'ui-kit';
import './UnauthLayout.scss';

interface Props {
  title?: string;
  subtitle?: string;
  // A narrow card with the logo inside it, for a page that is one message and one action.
  compact?: boolean;
  children: React.ReactNode;
}

export default function UnauthLayout({ children, title, subtitle, compact = false }: Props) {
  return (
    <section className={clsx('UnauthLayout', { 'UnauthLayout--compact': compact })}>
      {!compact && <Header />}
      <main className="UnauthLayout-container">
        <div className="UnauthLayout-container__content">
          <Card className="UnauthLayout-container__content-card">
            <CardContent>
              {compact && (
                <Link to="/" className="UnauthLayout-logo">
                  <Logo />
                </Link>
              )}
              {title && (
                <div className="UnauthLayout-container__content-card-title">
                  <Typography variant="h5">{title}</Typography>
                  {subtitle && (
                    <Typography variant="body2" color="textGray">
                      {subtitle}
                    </Typography>
                  )}
                </div>
              )}
              {children}
            </CardContent>
          </Card>
        </div>
      </main>
      <Footer />
    </section>
  );
}
